export enum ImportType {
  Weight = 'weight',
  Features = 'features',
}

// The `data` of the apiserver `weight_update_status` / `feature_update_status` settings.
export type ImportStatus = {
  updating: boolean
  previousSucceeded: boolean
  started: number
  ended: number
}

// Radio values as the legacy form posted them; '' until the analyst picks one.
export type ImportFlag = '' | 'true' | 'false'

export type WeightImportFormValues = {
  base: string
  store: string
  market: string
  date: Date | null
  test: ImportFlag
  updateGps: ImportFlag
  file: File | null
}

export type FeatureImportFormValues = {
  market: string
  store: string
  test: ImportFlag
  file: File | null
}
